/* tslint:disable */
/* eslint-disable */
/**
 * referral-network
 * referral-network
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DirectoryContact } from './DirectoryContact';
import {
    DirectoryContactFromJSON,
    DirectoryContactFromJSONTyped,
    DirectoryContactToJSON,
} from './DirectoryContact';

/**
 * 
 * @export
 * @interface ListDirectoryContactsResponse
 */
export interface ListDirectoryContactsResponse {
    /**
     * True when the provider is external (non-ExaCare); false for an internal ExaCare facility.
     * @type {boolean}
     * @memberof ListDirectoryContactsResponse
     */
    is_external: boolean;
    /**
     * 
     * @type {Array<DirectoryContact>}
     * @memberof ListDirectoryContactsResponse
     */
    data: Array<DirectoryContact>;
}

/**
 * Check if a given object implements the ListDirectoryContactsResponse interface.
 */
export function instanceOfListDirectoryContactsResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "is_external" in value;
    isInstance = isInstance && "data" in value;

    return isInstance;
}

export function ListDirectoryContactsResponseFromJSON(json: any): ListDirectoryContactsResponse {
    return ListDirectoryContactsResponseFromJSONTyped(json, false);
}

export function ListDirectoryContactsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListDirectoryContactsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'is_external': json['is_external'],
        'data': ((json['data'] as Array<any>).map(DirectoryContactFromJSON)),
    };
}

export function ListDirectoryContactsResponseToJSON(value?: ListDirectoryContactsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'is_external': value.is_external,
        'data': ((value.data as Array<any>).map(DirectoryContactToJSON)),
    };
}

